
    import { defineComponent, ref } from 'vue'

    import { Input } from '@progress/kendo-vue-inputs'
    import { Button } from '@progress/kendo-vue-buttons'

    import { buildLocalization } from '@/util'

    export default defineComponent({
        name: 'SearchInputForm',

        components: {
            'k-button': Button,
            'k-input': Input
        },

        props: {
            infoLabel: { type: String, required: true },
            placeholder: { type: String, required: true }
        },

        emits: {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            search: (value: string) => true
        },

        expose: ['setError'],

        setup(props, { emit }) {
            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const { localize } = buildLocalization()

            const inputValue = ref('')
            const searchError = ref<string | null>(null)

            /********************************************************************************************************************
             PUBLIC METHODS (exposed to parent via template ref)
             ********************************************************************************************************************/
            function setError(message: string | null) {
                searchError.value = message
            }

            /********************************************************************************************************************
             EVENT HANDLERS
             ********************************************************************************************************************/
            function onSearchClick() {
                searchError.value = null
                emit('search', inputValue.value)
            }

            function checkSubmit(e: KeyboardEvent) {
                searchError.value = null
                if (e.key == 'Enter') {
                    emit('search', inputValue.value)
                }
            }

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return {
                localize,
                inputValue,
                searchError,
                setError,
                onSearchClick,
                checkSubmit
            }
        }
    })
